import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { INLINE_MESSAGE_ICONS as o } from "./constants.js";
import r from "classnames";
import _ from "../icon/Icon.js";
import '../../assets/InlineMessage.css';const m = "_positive_1d2ej_14", l = "_warning_1d2ej_17", d = "_negative_1d2ej_20", g = "_informative_1d2ej_23", c = "_neutral_1d2ej_26", i = {
  "inline-message": "_inline-message_1d2ej_2",
  positive: m,
  warning: l,
  negative: d,
  informative: g,
  neutral: c
}, u = ({ type: e = "neutral", children: s, className: t }) => /* @__PURE__ */ a("span", { "data-testid": "inline-msg", className: r(i["inline-message"], i[e], t), children: [
  /* @__PURE__ */ n(_, { name: o[e] }),
  /* @__PURE__ */ n("span", { "data-testid": "inline-msg_text", children: s })
] });
export {
  u as default
};
